var map = {
	"./Hillary_online_world_real_world_video_cover.jpg": 1070,
	"./NWB_children_video_cover.jpg": 1071,
	"./btn_primaryschool_01_Generaltips.png": 1072,
	"./btn_primaryschool_02_Socialmediauserguide.png": 1073,
	"./btn_primaryschool_03_quiz.png": 1074,
	"./btn_primaryschool_04_onlinegrooming.png": 1075,
	"./btn_primaryschool_05_video.png": 1076,
	"./btn_primaryschool_06_game.png": 1077,
	"./btn_primaryschool_07_TheNetizenPledge.png": 1078,
	"./btn_primaryschool_ON.png": 1079,
	"./btn_seconaryschool_OFF.png": 1080
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1069;